module.exports = __webpack_public_path__ + "static/media/miniInstagramIcon.c7041c58.png";